import { render, staticRenderFns } from "./purchasePrice.vue?vue&type=template&id=7a4da8d9&scoped=true&"
import script from "./purchasePrice.vue?vue&type=script&lang=js&"
export * from "./purchasePrice.vue?vue&type=script&lang=js&"
import style0 from "./purchasePrice.vue?vue&type=style&index=0&id=7a4da8d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4da8d9",
  null
  
)

export default component.exports